// one prerendered page, no server rendering, no client-side routing
export const prerender = true
export const ssr = false
